<script>
export default {
  name: 'StarRating',
  props: {
    note: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div v-if="note" class="flex items-center gap-1">
    <i v-for="index in note" :key="'full-' + index" class="fa-solid fa-star text-yellow-300"></i>
    <i v-for="index in (5 - note)" :key="'empty-' + index" class="fa-regular fa-star text-yellow-300"></i>
  </div>

</template>
